import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPiggyController } from "./IPiggyController";
import { SceneManager } from "by/gamefactory/scene/SceneManager";
import { PiggyInfoPopupScene } from "../../piggyinfo/PiggyInfoPopupScene";
import { PiggyInfoType } from "../../piggyinfo/components/PiggyInfoType";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";

@injectable()
export class PiggyController implements IPiggyController {
    private readonly sceneManager: SceneManager;
    private readonly piggyInfoPopupSceneFactory: (type: PiggyInfoType) => Promise<PiggyInfoPopupScene>;
    private readonly asyncOperationNotification: AsyncOperationNotification;

    public constructor(
        sceneManager: SceneManager,
        @inject("PiggyInfoPopupSceneFactory") piggyInfoPopupSceneFactory: (type: PiggyInfoType) => Promise<PiggyInfoPopupScene>,
        asyncOperationNotification: AsyncOperationNotification
    ) {
        this.sceneManager = sceneManager;
        this.piggyInfoPopupSceneFactory = piggyInfoPopupSceneFactory;
        this.asyncOperationNotification = asyncOperationNotification;
    }

    public async showPiggyInfo(): Promise<void> {
        const scene = await this.asyncOperationNotification.autoShowHide(this.piggyInfoPopupSceneFactory(PiggyInfoType.PIGGY));
        await this.sceneManager.showViewableAsync(scene);
    }

    public async showTokenInfo(): Promise<void> {
        const scene = await this.asyncOperationNotification.autoShowHide(this.piggyInfoPopupSceneFactory(PiggyInfoType.TOKEN));
        await this.sceneManager.showViewableAsync(scene);
    }

    public async showCouponInfo(): Promise<void> {
        const scene = await this.asyncOperationNotification.autoShowHide(this.piggyInfoPopupSceneFactory(PiggyInfoType.COUPON));
        await this.sceneManager.showViewableAsync(scene);
    }
}
